import React, { useEffect } from 'react';
import MicroApp from '@/components/micro-app';
import { hideBreadCrumbs, showBreadCrumbs } from '@/components/bread-crumbs/update-crumb';
import goto from '@/common/goto';
import env from '@/env';

export default function Wareops() {
  useEffect(() => {
    hideBreadCrumbs();

    return showBreadCrumbs;
  }, []);

  return (
    <MicroApp
      destory
      data={{ merchantActivityInventory: goto.merchantActivityInventory }}
      name="wareops"
      url={env.WAREOPS_DOMAIN}
    />
  );
}
